module.exports = __webpack_public_path__ + "static/media/ClubNight1024738.c2fca211.png";